export const themeOptionFactory = (theme) => ({
  components: {
    DirectoryPage: {
      styleOverrides: {
        root: {
          height: "980px",
          paddingTop: theme.spacing(5),
          margin: "0px",
          overflow: "hidden auto",
          "&:after": {
            content: "' '",
            position: "absolute",
            top: 638,
            bottom: 0,
            left: 0,
            right: 0,
            background:
              "linear-gradient(180deg, rgba(248, 248, 255, 0), rgba(248, 248, 255, 1))",
            height: "190px",
            pointerEvents: "none",
            zIndex: 1,
          },
        },
        filterSection: {
          height: "176px",
          "& .category-filterbar,& .subCategory-filterbar": {
            maxWidth: "100%",
            padding: "0",
            margin: "0",
            "&:after": {
              width: "8%",
              background:
                "linear-gradient(90deg, rgba(248, 248, 255, 0.00) 10%, #F8F8FF 90%)",
              right: "-12px",
              pointerEvents: "none",
            },
            "&:before": {
              display: "none",
            },
          },
        },
        subCategoryFilterBar: {
          display: "none",
        },
        gridContainer: {
          gap: theme.spacing(1.5),
          padding: "0px",
          gridAutoFlow: "row",
          height: "740px",
          gridTemplateColumns: "repeat(5, max-content)",
          minHeight: "740px",
          "::-webkit-scrollbar": {
            display: "none",
          },
        },
        gridItem: {
          width: "180px",
          height: "250px",
        },
        categoryFilterBar: {
          marginTop: theme.spacing(2),
          gap: theme.spacing(3),
        },
        navigationWrapper: {
          padding: theme.spacing(0, 8),
        },
        actionContainer: {
          gap: theme.spacing(1.5),
          flexDirection: "row-reverse",
        },
        actionButton: {
          display: "none",
        },
        toolbarContainer: {
          gap: theme.spacing(1.25),
          flexDirection: "row-reverse",
        },
      },
    },
    VerticalDirectoryCard: {
      styleOverrides: {
        root: {
          height: "100%",
          borderRadius: "12px",
          border: "1px solid #E2E2E4",
          boxShadow: "none",
          padding: theme.spacing(1.5),
          position: "relative",
        },
        occupantLogo: {
          width: "156px",
          height: "156px",
          justifyContent: "center",
          alignItems: "center",
          "& .MuiAvatar-root": {
            borderRadius: "0",
            width: "100%",
            height: "100%",
          },
          "& .MuiAvatar-img": {
            objectFit: "cover",
          },
          "& .MuiSvgIcon-root": {
            width: "48px",
            height: "48px",
          },
        },
        titleText: {
          marginTop: theme.spacing(1),
          fontSize: "1rem",
          fontWeight: 700,
          color: "#494656",
          lineHeight: 1.1,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
          wordBreak: "break-word",
        },
        cardContent: {
          height: "68px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        },
        categoryText: {
          fontSize: "0.75rem",
          color: "#6A6A6A",
        },
        locationInfoContainer: {
          display: "flex",
          justifyContent: "center",
          position: "absolute",
          bottom: 4,
          right: 4,
          width: "32px",
          height: "32px",
          border: "1px solid #E2E2E4",
          backgroundColor: "#CCD5E7",
          textAlign: "center",
          borderRadius: "100px",
        },
        levelText: {
          color: "#002F87",
          fontWeight: 700,
        },
        chip: {
          position: "absolute",
          top: 16,
          left: 16,
          width: "29px",
          height: "20px",
          padding: theme.spacing(0.5),
          textAlign: "center",
          backgroundColor: "rgba(73, 70, 86, 0.6)",
          "& .MuiChip-label": {
            fontSize: "0.75rem",
            color: "#E2E2E4",
            padding: 0,
          },
        },
        statusTagContainer: {
          position: "absolute",
          top: 16,
          left: 16,
          zIndex: 1,
          display: "flex",
          gap: theme.spacing(1),
        },
        newShopChip: {
          height: "20px",
          "& .MuiChip-label": {
            fontSize: "0.75rem",
            padding: theme.spacing(0, 0.75),
          },
        },
        comingSoonChip: {
          height: "20px",
          "& .MuiChip-label": {
            fontSize: "0.75rem",
            padding: theme.spacing(0, 0.75),
          },
        },
      },
    },
    VerticalSkeletonDirectoryCard: {
      styleOverrides: {
        root: {
          width: "180px",
          height: "250px",
          padding: "12px",
        },
        avatar: {
          width: "156px",
          height: "156px",
        },
      },
    },
    HelpCenterButton: {
      styleOverrides: {
        root: {
          display: "flex",
          alignItems: "center",
          backgroundColor: "#fff",
          color: "#8C8A94",
          borderRadius: "20px",
          width: "166px",
          height: "64px",
          textTransform: "none",
          fontSize: "20px",
          fontWeight: 400,
          zIndex: 3,
          padding: theme.spacing(1.5, 1),
          border: "1px solid #E2E2E4",
          "&:hover": { backgroundColor: "#ffffff" },
          "& .MuiButton-startIcon": {
            marginRight: theme.spacing(0.5),
            display: "flex",
            alignItems: "center",
          },
          "& .MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
            color: "#8C8A94",
          },
        },
        backDrop: {
          zIndex: 2,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        },
        infoContainer: {
          marginTop: theme.spacing(0.75),
          borderRadius: "16px",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
          width: "200px",
          textAlign: "center",
          zIndex: 3,
        },
        headerContainer: {
          padding: theme.spacing(2, 1.5),
          backgroundColor: "#F3F3F4",
          "& .MuiTypography-root": {
            fontSize: "0.875rem",
            color: "#8C8A94",
          },
        },
        contactContainer: {
          display: "flex",
          alignItems: "center",
          padding: theme.spacing(2.5, 1.5),
          justifyContent: "center",
          gap: 1,
          borderRadius: "8px",
          color: "#8C8A94",
          "& .MuiTypography-root": {
            fontSize: "1.25rem",
          },
        },
      },
    },
  },
})
